var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Query } from 'react-apollo';
import { getVideoUrlQuery } from '../../gql/getVideoUrl';
var QueryS3Url = /** @class */ (function (_super) {
    __extends(QueryS3Url, _super);
    function QueryS3Url() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QueryS3Url.prototype.render = function () {
        var _this = this;
        return !this.props.source ? (this.props.children({ url: null })) : this.props.source.startsWith('http') ? (this.props.children({ url: this.props.source })) : (React.createElement(Query, __assign({}, getVideoUrlQuery(this.props.source, this.props.download)), function (_a) {
            var loading = _a.loading, error = _a.error, data = _a.data;
            return _this.props.children({
                loading: loading,
                error: error,
                url: data && data.getUrlRes && data.getUrlRes.signedUrl ? data.getUrlRes.signedUrl : null,
            });
        }));
    };
    return QueryS3Url;
}(React.PureComponent));
export { QueryS3Url };



//////////////////
// WEBPACK FOOTER
// ./src/components/reusable/QueryS3Url.tsx
// module id = 428
// module chunks = 81